module.exports = __webpack_public_path__ + "img/5d0db64.jpg";